import { ChevronRight } from 'lucide-react';

export interface BreakdownPath {
  category?: string;
  subcategory?: string;
}

interface BreakdownBreadcrumbProps {
  path: BreakdownPath;
  onNavigate: (path: BreakdownPath) => void;
}

export function BreakdownBreadcrumb({ path, onNavigate }: BreakdownBreadcrumbProps) {
  const crumbs: { level: string; label: string; target?: BreakdownPath }[] = [
    { level: 'all', label: 'All categories', target: {} },
    ...(path.category != null
      ? [{ level: 'category', label: path.category, target: path.subcategory != null ? { category: path.category } : undefined }]
      : []),
    ...(path.subcategory != null ? [{ level: 'subcategory', label: path.subcategory }] : []),
  ];

  return (
    <nav aria-label='Breakdown level' className='flex flex-wrap items-center gap-1 px-3 pt-2 pb-1 text-[12px]'>
      {crumbs.map(({ level, label, target }, i) => (
        <span key={level} className='flex items-center gap-1'>
          {i > 0 ? <ChevronRight className='size-3 text-gray-500' /> : null}
          {target ? (
            <button type='button' className='text-gray-700 hover:text-ink hover:underline' onClick={() => onNavigate(target)}>
              {label}
            </button>
          ) : (
            <span className='text-ink'>{label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
